import { i18N } from "../helper";
const NAME = 'wc_product_type';
AC_SERVICES.addListener('Editing.Editables.Ready', (Editables) => {
    const Abstract = Editables.get('_abstract');
    class ProductType extends Abstract {
        getEditableType() {
            return NAME;
        }
        focus() {
            this.getElement().querySelector('select').focus();
        }
        render() {
            let select = this.getElement().querySelector('select');
            Object.keys(this.settings.options).forEach((k) => {
                let option = this.settings.options[k];
                select.append(new Option(option.label, option.value));
            });
            select.addEventListener('change', () => this.checkSimpleType());
        }
        getType() {
            return this.getElement().querySelector('select[name=type]').value;
        }
        isExtendedType() {
            return this.settings.simple_types.includes(this.getType());
        }
        checkSimpleType() {
            this.showSimpleFields(false);
            if (this.isExtendedType()) {
                this.showSimpleFields(true);
            }
        }
        showSimpleFields(show = true) {
            this.getElement().querySelector('.input__group.-type_props').style.display = show ? 'block' : 'none';
        }
        getDownloadableCheckbox() {
            return this.getElement().querySelector('[name=downloadable]');
        }
        getVirtualCheckbox() {
            return this.getElement().querySelector('[name=virtual]');
        }
        valueToInput(value) {
            if (!value) {
                return;
            }
            this.getElement().querySelector('select').value = value.type;
            this.getDownloadableCheckbox().checked = value.downloadable;
            this.getVirtualCheckbox().checked = value.virtual;
            this.checkSimpleType();
        }
        getValue() {
            return {
                type: this.getElement().querySelector('select').value,
                downloadable: this.getDownloadableCheckbox().checked,
                virtual: this.getVirtualCheckbox().checked
            };
        }
        getTemplate() {
            return `
				<div class="input__group">
					<select name="type"></select>
				</div>
				<div class="input__group -type_props">
					<label><input type="checkbox" name="downloadable">${i18N().downloadable}</label>
					<label><input type="checkbox" name="virtual">${i18N().virtual}</label>
				</div>
			`;
        }
    }
    Editables.registerEditable(NAME, ProductType);
});
AC_SERVICES.addListener('Editing.Middleware.Ready', (Middleware) => {
    const Abstract = Middleware.getClass('_abstract');
    class ProductType extends Abstract {
        map() {
            this.args.options = this.settings.options;
            this.args.simple_types = this.settings.simple_types;
            return this.args;
        }
        getEditable() {
            return this.Editables.get(NAME);
        }
    }
    Middleware.register(NAME, ProductType);
});
